<script>
import { onMount, createEventDispatcher } from 'svelte';

export let audio
export let currentTime = 0
export let duration
export let voicePath

const dispatch = createEventDispatcher()

onMount(() => {
  audio.src = voicePath;
  audio.currentTime = 1000000 // durationを取得するために最後までシーク
  audio.load()
})

export function play() {
  audio.currentTime = 0
  currentTime = 0
  audio.play()
}
function end() {
  audio.pause()
  dispatch('end')
}
function timeUpdate() {
  currentTime = audio.currentTime
}
function loadMetaData() {
  duration = audio.duration
}
</script>

<audio
  preload="auto"
  bind:this={audio}
  on:timeupdate={timeUpdate}
  on:canplaythrough={loadMetaData}
  on:ended={end}>
</audio>
